// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DepartmentFromJSON(json) {
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'departmentID': !exists(json, 'departmentID') ? undefined : json['departmentID'],
        'departmentCode': !exists(json, 'departmentCode') ? undefined : json['departmentCode'],
        'departmentName': !exists(json, 'departmentName') ? undefined : json['departmentName'],
        'departmentHead': !exists(json, 'departmentHead') ? undefined : json['departmentHead'],
    };
}
export function DepartmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'departmentID': value.departmentID,
        'departmentCode': value.departmentCode,
        'departmentName': value.departmentName,
        'departmentHead': value.departmentHead,
    };
}
